import {ChartEventsDomainModel} from "../chart-events.domain-model";
import {AthleteChartEventsApiModel} from "./athlete-chart-events.api-model";
import {MemberDomainModel} from "../../../../yard/member/member-domain-model";
import {PartialGameDomainModel} from "../../../../partial-game/models/partial-game-domain-model";
import {AthleteDomainModel} from "../../../../common/athlete/athlete-domain-model";


export class AthleteChartEventsDomainModel extends ChartEventsDomainModel {
  mostCommonGoalZone: Array<String>;
  penaltyGoals: String;
  penaltyConversions: String;
  athlete: AthleteDomainModel;

  constructor(model: AthleteChartEventsApiModel, members: Map<MemberDomainModel>, gameMap: Map<Number, PartialGameDomainModel>, athlete: AthleteDomainModel){
    super(model, members, gameMap);

    this.mostCommonGoalZone = model.mostCommonGoalZone;
    this.penaltyGoals = model.penaltyGoals;
    this.penaltyConversions = model.penaltyConversions;
    this.athlete = athlete;
  }
}
